export const LABEL_TYPE = {
  H1: 'H1',
  H2: 'H2',
  PARAGRAPH1: 'PARAGRAPH1',
  PARAGRAPH2: 'PARAGRAPH2',
  BUTTON_PRIMARY: 'BUTTON_PRIMARY',
  BUTTON_SECONDARY: 'BUTTON_SECONDARY',
  PARAGRAPH2_BOLD: 'PARAGRAPH2_BOLD',
  H3_BOLD: 'H3_BOLD',
  H3: 'H3',
  PARAGRAPH3_BOLD: 'PARAGRAPH3_BOLD',
  H4_BOLD: 'H4_BOLD',
  PARAGRAPH1_BOLD: 'PARAGRAPH1_BOLD',
  H4: 'H4',
  HEADER_SENTOA: 'HEADER_SENTOA',
  BUTTON_SIDEBAR: 'BUTTON_SIDEBAR',
  PARAGRAPH_ERROR: 'PARAGRAPH_ERROR',
  STATUS_LABEL: 'STATUS_LABEL',
  ASSET_SLOT_NAME_LABEL: 'ASSET_SLOT_NAME_LABEL'
};

export const DEFAULT_LABEL_CLASSES = ['flex', 'flex-row', 'items-center'].join(' ');
export const PARAGRAPH1_BOLD_CLASSES = ['text-base', 'font-semibold'].join(' ');
export const PARAGRAPH1_NORMAL_CLASSES = [
  'text-sm',
  'sm:text-base',
  'font-normal',
  'text-secondary-gray'
].join(' ');
export const PARAGRAPH2_BOLD_CLASSES = ['text-sm', 'font-bold'].join(' ');
export const PARAGRAPH2_NORMAL_CLASSES = ['text-sm', 'font-normal'].join(' ');
export const PARAGRAPH3_BOLD_CLASSES = ['text-xs', 'font-bold'].join(' ');
export const PARAGRAPH_ERROR_CLASSES = ['text-sm', 'font-normal', 'text-accent-red'].join(' ');
export const H1_CLASSES = ['text-xl', 'md:text-4xl', 'font-semibold', 'text-primary-blue'].join(
  ' '
);
export const H2_CLASSES = ['text-xl', 'sm:text-2xl', 'font-bold', 'text-primary-blue'].join(' ');
export const H3_BOLD_CLASSES = ['text-xl', 'font-semibold', 'text-primary-black'].join(' ');
export const H3_CLASSES = ['text-xl', 'font-medium', 'text-primary-black'].join(' ');
export const H4_BOLD_CLASSES = ['text-lg', 'font-bold', 'text-primary-blue'].join(' ');
export const H4_CLASSES = ['text-lg', 'font-semibold'].join(' ');
export const HEADER_SENTOA_CLASSES = [
  'text-3xl',
  'font-light',
  'font-poppins',
  'text-primary-blue',
  'uppercase'
].join(' ');
export const STATUS_LABEL_CLASSES = [
  'text-xs',
  'sm:text-sm',
  'font-normal',
  'text-secondary-gray',
  'whitespace-normal',
  'break-words',
  'text-center',
  'w-full'
].join(' ');
export const ASSET_SLOT_NAME_LABEL_CLASSES = [
  'block',
  'w-full',
  'truncate',
  'whitespace-nowrap',
  'overflow-hidden',
  'bg-blue-powder',
  'text-primary-black',
  'text-xs',
  'px-2',
  'text-start',
  'h-4',
  'rounded'
].join(' ');

export const LABEL_CLASSES = {
  [LABEL_TYPE.PARAGRAPH1]: `${DEFAULT_LABEL_CLASSES} ${PARAGRAPH1_NORMAL_CLASSES}`,
  [LABEL_TYPE.PARAGRAPH2]: `${DEFAULT_LABEL_CLASSES} ${PARAGRAPH2_NORMAL_CLASSES}`,
  [LABEL_TYPE.PARAGRAPH2_BOLD]: `${DEFAULT_LABEL_CLASSES} ${PARAGRAPH2_BOLD_CLASSES}`,
  [LABEL_TYPE.H1]: `${DEFAULT_LABEL_CLASSES} ${H1_CLASSES}`,
  [LABEL_TYPE.H3_BOLD]: `${DEFAULT_LABEL_CLASSES} ${H3_BOLD_CLASSES}`,
  [LABEL_TYPE.H3]: `${DEFAULT_LABEL_CLASSES} ${H3_CLASSES}`,
  [LABEL_TYPE.PARAGRAPH3_BOLD]: `${DEFAULT_LABEL_CLASSES} ${PARAGRAPH3_BOLD_CLASSES}`,
  [LABEL_TYPE.H2]: `${DEFAULT_LABEL_CLASSES} ${H2_CLASSES}`,
  [LABEL_TYPE.H4_BOLD]: `${DEFAULT_LABEL_CLASSES} ${H4_BOLD_CLASSES}`,
  [LABEL_TYPE.PARAGRAPH1_BOLD]: `${DEFAULT_LABEL_CLASSES} ${PARAGRAPH1_BOLD_CLASSES}`,
  [LABEL_TYPE.H4]: `${DEFAULT_LABEL_CLASSES} ${H4_CLASSES}`,
  [LABEL_TYPE.HEADER_SENTOA]: `${DEFAULT_LABEL_CLASSES} ${HEADER_SENTOA_CLASSES}`,
  [LABEL_TYPE.PARAGRAPH_ERROR]: `${DEFAULT_LABEL_CLASSES} ${PARAGRAPH_ERROR_CLASSES}`,
  [LABEL_TYPE.STATUS_LABEL]: `${STATUS_LABEL_CLASSES}`,
  [LABEL_TYPE.ASSET_SLOT_NAME_LABEL]: `${ASSET_SLOT_NAME_LABEL_CLASSES}`
};
